module.exports = __webpack_public_path__ + "img/avatar.cbb8740b.jpg";